export const StatusType = [
  {
    name: 'Todos',
    value: 0
  },
  {
    name: 'Ingresado',
    value: 1
  },
  {
    name: 'Confirmado',
    value: 3
  },
  {
    name: 'Recaudado',
    value: 4
  },
  {
    name: 'Devuelto',
    value: 6
  },
  {
    name: 'Anulado',
    value: 7
  }
];

const getStatusTypeByIds = (ids: Array<number>) => {
  var newArray = StatusType.filter(function (statusType) {
    return ids.includes(statusType.value);
  });

  return newArray;
}

export {
  getStatusTypeByIds
}